import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import TextRenderer from './../TextRenderer'

import styles from './styles.module.scss'

const Feature = (props) => {
	
	const iconClasses = cx({
		[styles['feature-item__icon']]: true,
		[styles['feature-item__icon--normal']]: props.blok.icon_size == 'normal',
		[styles['feature-item__icon--large']]: props.blok.icon_size == 'large',
		[styles['feature-item__icon--extra-large']]: props.blok.icon_size == 'extra-large'
	})

	return (
		<>
			<div className={styles['feature-item__icon-wrapper']}>
				{props.blok.icon.filename && (
					<img className={iconClasses} src={props.blok.icon.filename} alt={props.blok.icon.alt} />
				)}
			</div>
			<SbEditable content={props.blok}>
				<div className={styles['feature-item__content']}>
					<TextRenderer className={styles['feature-item__title']} text={props.blok.title} />
					<TextRenderer className={styles['feature-item__description']} text={props.blok.description} />
				</div>
			</SbEditable>
		</>
	)
}

export default Feature
